import React, { useState, useEffect } from "react";
import Select from "react-select";
import Modal from "react-modal";

/*const extractYouTubeId = (url) => {
  if (!url) return null;

  const regex =
    /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:shorts\/|watch\?.*?v=|embed\/|v\/))([\w-]{11})/;

  const match = url.match(regex);
  return match ? match[1] : null;
};*/

const extractYouTubeId = (url) => {
  console.log("extractYouTubeId called with:", url);
  if (!url) return null;
  try {
    const u = new URL(url);
    console.log("pathname:", u.pathname);
    if (u.pathname.includes("/shorts/")) {
      const id = u.pathname.split("/shorts/")[1].split("?")[0];
      console.log("Shorts ID:", id);
      return id;
    }
    if (u.hostname === "youtu.be") {
      return u.pathname.slice(1).split("?")[0];
    }
    return u.searchParams.get("v");
  } catch(e) {
    console.log("URL parse error:", e);
    return null;
  }
};

const extractYouTubeThumbnail = (url) => {
  const id = extractYouTubeId(url);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
};

// SingleSelectExerciseList Component
const SingleSelectExerciseList = ({
  exercises = [],
  value,
  onChange,
  resetTrigger,
}) => {
  const [playingVideo, setPlayingVideo] = useState(null);

  // Transform exercises to the format needed for the select component
  const options = exercises.map((exercise) => ({
    value: exercise._id, // This will be used to identify the selected option
    label: exercise.title, // This will be shown in the dropdown
    tags: exercise.tags || [], // Tags for filtering search
    thumbnail: extractYouTubeThumbnail(exercise.video_url), // Thumbnail image
    videoUrl: exercise.video_url, // Actual video URL
  }));

  // Filter exercises based on the search input
  const filterExercises = (inputValue) => {
    return options.filter(
      (exercise) =>
        exercise.label.toLowerCase().includes(inputValue.toLowerCase()) ||
        exercise.tags.some((tag) =>
          tag.toLowerCase().includes(inputValue.toLowerCase()),
        ),
    );
  };

  return (
    <>
      <div className="w-full flex max-sm:flex-col sm:items-end gap-3">
        <div className="order-2 w-full flex flex-col justify-end">
          <label
            htmlFor="exercise"
            className="block text-slate100 font-inter font-normal text-xs mb-2"
          >
            Exercise
          </label>
          <div className="exercise-select">
            <Select
              isClearable
              options={options}
              value={options.find((opt) => opt.value === value) || null}
              getOptionLabel={(e) => (
                <div className="flex items-center">
                  {e.thumbnail ? (
                    <img
                      src={e.thumbnail}
                      alt="Thumbnail"
                      className="w-8 h-8 rounded-sm mr-2 cursor-pointer"
                      onClick={(ev) => {
                        ev.stopPropagation();
                        setPlayingVideo(e.videoUrl);
                      }}
                    />
                  ) : (
                    <span className="w-8 h-8 flex items-center justify-center bg-gray-200 text-xs rounded-sm mr-2">
                      No Video
                    </span>
                  )}
                  <span>{e.label}</span>
                </div>
              )}
              getOptionValue={(e) => e.value}
              placeholder="Search exercise..."
              onChange={(selectedOption) => {
                onChange(selectedOption?.value || null);
              }}
              filterOption={({ data }, inputValue) =>
                filterExercises(inputValue).some(
                  (ex) => ex.value === data.value,
                )
              }
              className="w-full !text-dark !font-inter !font-medium !text-sm md:!text-base !outline-none !placeholder:font-inter !placeholder:font-normal"
            />
          </div>
        </div>

        <div className="w-12 h-12 lg:w-16 lg:h-16 shrink-0">
        {value && (
          <>
            <div
              className="w-full h-full inline-block cursor-pointer rounded-lg overflow-hidden hover:opacity-80 transition order-1"
              onClick={() => {
                const selected = options.find((opt) => opt.value === value);
                if (selected?.videoUrl) setPlayingVideo(selected.videoUrl);
              }}
            >
              <img
                src={extractYouTubeThumbnail(
                  options.find((opt) => opt.value === value)?.videoUrl,
                )}
                alt="Selected Thumbnail"
                className="w-full h-full object-cover rounded-lg border border-tblBorder"
              />
            </div>
          </>
        )}
        </div>

        {/* Video Modal */}
        <Modal
          isOpen={!!playingVideo}
          onRequestClose={() => setPlayingVideo(null)}
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
        >
          <div className="bg-white p-4 rounded-lg w-3/4 max-w-2xl relative">
            <button
              className="absolute top-2 right-3 text-xl font-bold leading-none text-black bg-white w-10 h-10 flex justify-center items-center rounded-full"
              onClick={() => setPlayingVideo(null)}
            >
              ✖
            </button>
            <iframe
              width="100%"
              height="400"
              src={`https://www.youtube.com/embed/${extractYouTubeId(playingVideo)}?autoplay=1`}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="Video Player"
            ></iframe>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default SingleSelectExerciseList;
